const types = {
  LOAD: 'app/balance/LOAD',
  LOAD_SUCCESS: 'app/balance/LOAD_SUCCESS',
  LOAD_FAIL: 'app/balance/LOAD_FAIL',
  RESET: 'app/balance/RESET',
};

export default types;
